import { render, staticRenderFns } from "./approved-approval.vue?vue&type=template&id=2858c348&scoped=true"
import script from "./approved-approval.vue?vue&type=script&lang=js"
export * from "./approved-approval.vue?vue&type=script&lang=js"
import style0 from "./approved-approval.vue?vue&type=style&index=0&id=2858c348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858c348",
  null
  
)

export default component.exports